import { render } from "./editReserveComponent.vue?vue&type=template&id=1ada640e&scoped=true"
import script from "./editReserveComponent.vue?vue&type=script&lang=js"
export * from "./editReserveComponent.vue?vue&type=script&lang=js"

import "./editReserveComponent.vue?vue&type=style&index=0&id=1ada640e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ada640e"]])

export default __exports__